module.exports = __webpack_public_path__ + "static/img/dyHoverTop.f282061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer/dyHoverTop.png
// module id = awo2
// module chunks = 12